export class ChipnumberInvalidError extends Error {

  code?: string = 'auth/chipnumber-invalid';
}
